export enum CONDITION {
  NO = 'N',
  YES = 'S',
}
